//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconView from "@/components/objects/IconView.vue";
import AsyncObjectSnippetTooltip from "@/components/AsyncObjectSnippetTooltip.vue";
import { DesignExtra } from "@/utils/dto/objects.js";
import { alphabet } from '@/constants/translate.js';
import { adjustColorBrightness } from "@/utils/helpers.js";
import TheCustomScroll from "@/components/TheCustomScroll.vue";
import isEqual from 'lodash/isEqual'

export default {
  name: "Radius",
  components: { IconView, AsyncObjectSnippetTooltip, TheCustomScroll },
  inject: {
    specialProject: {
      default: false
    }
  },
  props: {
    tableData: {
      type: Object,
      default: () => ({ rows: [], meta: {}, columns: [], is_numeric: false, amount: {}, options: {} })
    },
    label: {
      type: String,
      required: false,
      default: () => ''
    },
    objectLabel: {
      type: String,
      required: false,
      default: () => ''
    },
    design: {
      type: String,
    },
    design_extra: {
      type: [Object, DesignExtra],
      default: () => {}
    },
    template: {
      type: Object,
      default: () => null
    },
    listInfo: {
      type: Object,
      default: () => ({})
    },
    user: {
      type: Object,
      default: () => {}
    },
    theme: {
      type: String,
    },
  },
  data() {
    return {
      domId: '',
      slicedRows: (this.tableData.rows || []).slice(0, 20),
    }
  },
  computed: {
    hasColumnWithTitle() {
      return this.tableData.columns.filter(col => col && col.title).length;
    },
    slicedRowsLessAllRows() {
      return this.slicedRows.length < this.tableData.rows.length;
    },
    paletteList() {
      return this.$store.state["property_templates"]["consts"].palette;
    },
    bgPalette() {
      if (this.design_extra?.bg?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.bg.palette)[0];
      }

      return null;
    },
    blockBorderPalette() {
      if (this.design_extra?.block_border?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.block_border.palette)[0];
      }

      return null;
    },
    iconBorderPalette() {
      if (this.design_extra?.icon_border?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.icon_border.palette)[0];
      }

      return null;
    },
    iconBgPalette() {
      if (this.design_extra?.icon_bg?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.icon_bg.palette)[0];
      }

      return null;
    },
    getTextColor() {
      return this.design_extra?.text?.color ?? null;
    },
    getFirstBlockBg() {
      if (this.getFirstBlockBgGradientEnabled) {
        return `linear-gradient(to ${this.getFirstBlockBgGradientDirection}, ${this.getFirstBlockBgGradientShadowDirection === 'transparent' ? `${this.getFirstBlockBgColor}, transparent` : `${this.getFirstBlockBgColor}, ${adjustColorBrightness(this.getFirstBlockBgColor, 1.20)}`})`
      }
      return this.getFirstBlockBgColor ?? null;
    },
    getFirstBlockBgColor() {
      if (this.design_extra?.first_block?.bg_color) {
        return this.design_extra?.first_block?.bg_color
      } else {
        if (this.bgPalette) {
          return this.bgPalette.main_color;
        } else if (this.design_extra?.bg?.color) {
          return this.design_extra.bg.color;
        }
      }

      return null;
    },
    getFirstBlockBgGradientEnabled() {
      if (this.hasNotFirstBlockBgAndHasBgPalette) {
        return this.design_extra?.bg?.gradient_enabled ?? null;
      } else {
        return this.design_extra?.first_block?.gradient_enabled ?? null;
      }
    },
    getFirstBlockBgGradientDirection() {
      if (this.hasNotFirstBlockBgAndHasBgPalette) {
        return this.design_extra?.bg?.gradient_direction ?? null;
      } else {
        return this.design_extra?.first_block?.gradient_direction ?? null;
      }
    },
    getFirstBlockBgGradientShadowDirection() {
      if (this.hasNotFirstBlockBgAndHasBgPalette) {
        return this.design_extra?.bg?.gradient_shadow_direction ?? null;
      } else {
        return this.design_extra?.first_block?.gradient_shadow_direction ?? null;
      }
    },
    getFirstBlockTitleColor() {
      return this.design_extra?.first_block?.title_color ?? 'rgba(0, 0, 0, 0.65)' ?? null;
    },
    getBlockBorderColor() {
      if (this.blockBorderPalette) {
        return this.blockBorderPalette.main_color;
      } else if (this.design_extra?.block_border?.color) {
        return this.design_extra.block_border.color
      }

      return null;
    },
    getIconBorder() {
      let color;
      if (this.iconBorderPalette) {
        color = this.iconBorderPalette.main_color;
      } else if (this.design_extra?.icon_border?.color) {
        color = this.design_extra.icon_border.color
      } else {
        return null
      }

      return { border: `1px solid ${color}` }
    },
    getIconBg() {
      if (this.iconBgPalette) {
        return { backgroundColor: this.iconBgPalette.main_color };
      } else if (this.design_extra?.icon_bg?.color) {
        return { backgroundColor: this.design_extra.icon_bg.color }
      }

      return null
    },
    getBgGradientEnabled() {
      return this.design_extra?.bg?.gradient_enabled ?? null;
    },
    getBgGradientDirection() {
      return this.design_extra?.bg?.gradient_direction ?? null;
    },
    getBgGradientShadowDirection() {
      return this.design_extra?.bg?.gradient_shadow_direction ?? null;
    },
    hasNotFirstBlockBgAndHasBgPalette() {
      if (!this.design_extra?.first_block?.bg_color && this.bgPalette) {
        return true;
      } else return false;
    },
    getIconColor() {
      return this.design_extra?.icon_color?.color ?? 'black';
    },
    adjustColorBrightness() {
      return adjustColorBrightness
    },
    firstColumnHasIcon() {
      if (this.tableData.meta[0]) {
        return Object.values(this.tableData.meta[0]).filter(el => el.payload && el.payload.icon).length;
      } else return false;
    },
  },
  mounted() {
    this.domId = `tables-${this.listInfo.id}`
  },
  methods: {
    hasHeadIcon(index) {
      return this.tableData.meta[index] && this.tableData.meta[index]['-1'] && this.tableData.meta[index]['-1'].payload.icon;
    },
    hasBodyIcon(colIndex, rowIndex) {
      return this.tableData.meta[colIndex] && this.tableData.meta[colIndex][rowIndex] && this.tableData.meta[colIndex][rowIndex].payload.icon;
    },
    isAmountRow(row) {
      const arr = this.tableData?.amount?.rows || []
      try {
        return arr.some(el => isEqual(el, row))
      } catch (e) {
        return false
      }
    },
    isAmountColumn(column) {
      const arr = this.tableData?.amount?.columns || []
      try {
        return arr.some(el => isEqual(el, column))
      } catch (e) {
        return false
      }
    },
    getBgColor(index) {
      if (this.bgPalette) {
        const color = [this.bgPalette.main_color, ...this.bgPalette.colors][index % [this.bgPalette.main_color, ...this.bgPalette.colors].length];

        if (this.getBgGradientEnabled) {
          return `linear-gradient(to ${this.getBgGradientDirection}, ${this.getBgGradientShadowDirection === 'transparent' ? `${color}, transparent` : `${color}, ${adjustColorBrightness((color), 1.20)}`})`
        }
        return color;

      } else if (this.design_extra?.bg?.color) {
        const color = this.design_extra.bg.color;
        if (this.getBgGradientEnabled) {
          return `linear-gradient(to ${this.getBgGradientDirection}, ${this.getBgGradientShadowDirection === 'transparent' ? `${color}, transparent` : `${color}, ${adjustColorBrightness((color), 1.20)}`})`
        }
        return color;
      }

      return null;
    },
    getColumnTitle(index) {
      let n = Number(index)
      if (!Number.isFinite(n) || n < 0) return ''
      let result = ''
      n = n + 1
      while (n > 0) {
        const rem = (n - 1) % alphabet.length
        result = String(alphabet[rem] || '') + result
        n = Math.floor((n - 1) / alphabet.length)
      }
      return result
    },
    getHeadLabel(label, index) {
      if (label && String(label).trim() !== '') return label
      return this.getColumnTitle(index)
    },
    reduceCommaToDot(value) {
      if (value && typeof value === 'Number') {
        return value;
      }
      return value.replace(',', '.');
    },
    calcAmount(array, colIndex) {
      const amount = array.reduce((accum, val) => {
        return accum + (Number(this.reduceCommaToDot((colIndex || colIndex === 0) ? val[colIndex] : val)) ? Number(this.reduceCommaToDot((colIndex || colIndex === 0) ? val[colIndex] : val)) : 0)
      }, 0);

      return parseFloat(amount.toFixed(2));
    }
  }
}
